import React, { ReactElement, useMemo } from 'react';
import { Text } from 'rsuite';
import { convertNumberToCurrency } from '../../../common/utils';
import LabelWithInfoIcon from '../../common/LabelWithInfoIcon';

interface TaxBreakdownItemProps {
  title: string;
  value: number | string;
  bold?: boolean;
  infoText?: string;
}

export const TaxBreakdownItem = ({
  title = '',
  value,
  bold,
  infoText,
}: TaxBreakdownItemProps): ReactElement => {
  const currencyValue = useMemo(() => convertNumberToCurrency(value), [value]);
  return (
    <tr
      data-testid={`taxbreakdown-${title}`}
      style={{ fontWeight: bold ? 'bold' : 'normal' }}
    >
      <th
        scope="row"
        style={{ padding: '4px 0', fontWeight: 'inherit', textAlign: 'left' }}
      >
        <LabelWithInfoIcon
          label={title}
          infoText={infoText}
        />
      </th>
      <td style={{ textAlign: 'right', padding: '4px 0' }}>
        <Text>{currencyValue}</Text>
      </td>
    </tr>
  );
};
